module.exports = __webpack_public_path__ + "static/img/t4.0bf0ae72.png";